import { gql } from '@apollo/client';

export const GET_USER_ACCOUNT_ALERTS = gql`
	query GetUserAccountAlerts($id: ID!) {
		user(id: $id) {
			id
			binReminderEnabled
			userAlerts {
				id
				frequency
				day
				time
				from
			}
		}
	}
`;

export const UPDATE_USER_ACCOUNT_ALERTS_NESTED = gql`
	mutation UpdateUserAccountAlertsNested(
		$alertInput: [UserAlertCreateOrUpdateInput!]!
		$userInput: UserUpdateInput!
	) {
		alerts: createOrUpdateUserAlerts(input: $alertInput) {
			id
		}
		user: updateUser(input: $userInput) {
			id
		}
	}
`;
